import React from 'react'
import { Highlight, themes } from 'prism-react-renderer'
import '../utils/prism-languages'

export const Code = ({ codeString, language }) => (
  <Highlight theme={themes.github} code={codeString} language={language}>
    {({ className, style, tokens, getLineProps, getTokenProps }) => (
      <pre className={className} style={style}>
        {tokens.map((line, i) => (
          <div key={i} {...getLineProps({ line })}>
            {line.map((token, key) => (
              <span key={key} {...getTokenProps({ token })} />
            ))}
          </div>
        ))}
      </pre>
    )}
  </Highlight>
)
